import clsx from 'clsx';
import styles from './WaermwendeProjectContainer.module.scss';

type WaermwendeProjectContainerProps = {
  children: React.ReactNode;
  variant?: 'default' | 'wide';
};

const WaermwendeProjectContainer = ({
  children,
  variant = 'default',
}: WaermwendeProjectContainerProps) => {
  return <div className={clsx(styles.base, styles[variant])}>{children}</div>;
};

export default WaermwendeProjectContainer;
